/**
 * Enterprise switcher rendered in NavigationBar.otherButtons.
 * Uses NavigationMenuItem to match other nav-bar dropdown styling.
 * Replaces legacy redux-form EnterpriseListForm + spark-ui SelectField in HeaderBar.
 */
import React, { useMemo } from 'react';
import styled from 'styled-components';
import NavigationMenuItem from 'apollo-react/components/NavigationBar/NavigationMenuItem';
import { useHistory } from 'react-router-dom';
import { NAVIGATION_BAR_CONFIG } from './navigationBarConfig';

const MenuContainer = styled.div`
    display: flex;
    align-items: center;
    height: 55px;
    margin-right: 8px;
`;

const normalizeEnterpriseId = (id) => {
    // Redux enterpriseId may be string; menu item values are numbers.
    if (id == null || id === '') {
        return null;
    }
    return Number(id);
};

const EnterpriseSelect = ({ mappedEnterprise, enterpriseId, getMappedEnterprises, userInfo }) => {
    const history = useHistory();
    const options = useMemo(
        () => (mappedEnterprise && mappedEnterprise.length ? mappedEnterprise : []),
        [mappedEnterprise]
    );
    const value = normalizeEnterpriseId(enterpriseId);

    const selectedEnterprise = useMemo(
        () => options.find((enterprise) => normalizeEnterpriseId(enterprise.entId) === value),
        [options, value]
    );

    const menuItems = options.map((enterprise) => ({
        text: enterprise.entName,
        active: normalizeEnterpriseId(enterprise.entId) === value,
    }));

    const handleClick = (item) => {
        const enterprise = options.find((option) => option.entName === item.text);
        if (enterprise) {
            getMappedEnterprises(
                normalizeEnterpriseId(enterprise.entId),
                history,
                userInfo,
                mappedEnterprise
            );
        }
    };

    if (!value || !selectedEnterprise) {
        // Avoid empty nav-bar slot while enterprise list or selection is still loading.
        return null;
    }

    return (
        <MenuContainer>
            <NavigationMenuItem
                variant={NAVIGATION_BAR_CONFIG.variant}
                text={selectedEnterprise.entName}
                menuItems={menuItems}
                onClick={handleClick}
            />
        </MenuContainer>
    );
};

export default EnterpriseSelect;
